import baseUrl from './baseUrl';

const URL_GET_USER_BY_ID = `${baseUrl}/user`;

const getUserById = async id => {
  try {
    const data = await fetch(`${URL_GET_USER_BY_ID}/${id}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getUserById;
